/* eslint-disable */
export default {
  forward: 'Forward',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
